import React from "react";
import Marquee from "react-fast-marquee";
import * as Icon from "@phosphor-icons/react/dist/ssr";
import { DEFAULT_HOME_TOP_PROMO_TEXTS } from "../../utils/promoText";

interface Props {
  props: string;
  textColor: string;
  bgLine: string;
  messages?: string[];
}

const BannerTop: React.FC<Props> = ({
  props,
  textColor,
  bgLine,
  messages,
}) => {
  const lines =
    messages && messages.length > 0 ? messages : DEFAULT_HOME_TOP_PROMO_TEXTS;

  return (
    <div className="flex justify-end">
      <div
        className={`banner-top flex items-center ${props} 2xl:w-[98%] xl:w-[98%] lg:w-[98%] max-md:w-full 2xl:rounded-tl-xl xl:rounded-t-xl  lg:rounded-t-xl max-md:rounded-tl-none`}
      >
        <div
          className="fx-reveal md:w-2/12 2xl:flex xl:flex lg:flex hidden items-center justify-center gap-3 text-center text-white border-r"
        >
          <Icon.List size={16} className="text-white font-bold" />
          <h3 className="font-bold">All Categories</h3>
        </div>
        <Marquee className="menu-slid fx-reveal">
          {lines.map((text, index) => (
            <React.Fragment key={`${index}-${text.slice(0, 24)}`}>
              <div className={`text-button-uppercase px-8 ${textColor}`}>
                {text}
              </div>
              <div className={`line w-8 h-px ${bgLine}`}></div>
            </React.Fragment>
          ))}
        </Marquee>
      </div>
    </div>
  );
};

export default BannerTop;
